(function ($) {
  $(document).ready(function () {
    if ($('.col-three-grid').length > 0) {
      $('.col-three-grid .outer .option').on('click', function (e) {
        e.stopPropagation();
        var text = $(this).find('span').text();
        $('.col-three-grid .select-field .select-text').text(text);
        $(".col-three-grid .outer .list").slideToggle();
        $(".col-three-grid .outer .select-field").removeClass("rotate");
      });

      $(".col-three-grid .outer .select-field").click(function (e) {
        e.stopPropagation();
        $(this).toggleClass("rotate");
        $(".col-three-grid .outer .list").toggleClass("show");
        $(".col-three-grid .outer .list").slideToggle();
      });

      $(document).on('click', function (e) {
        e.stopPropagation();
        $(".col-three-grid .outer .list").slideUp();
        $(".col-three-grid .outer .select-field").removeClass("rotate");
        $(".col-three-grid .outer .list").removeClass("show");
      });
    }
  });
})(jQuery);
